<template>
    <div>
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <b-media>
                    <template v-slot:aside>
                        <img src="@/assets/img/icon_directory.png" class="ml-0" alt="MUIC">
                    </template>
                    <h4 style="font-weight:100" class="font-en mt-3 mb-0">Directory</h4>
                    <p class="mt-0 mb-0">Search for personnel information</p>
                </b-media>
                <b-form-group
                    class="mt-3 mb-2"
                    description="Specify the information to be searched"
                >
                    <b-input-group>
                        <b-form-input 
                            list="my-list-id"
                            placeholder="Search..."
                            @keyup="queryDataTy"
                            v-model="newQuery"
                            v-on:keyup.enter="renderCardProfile"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button class="font-en" @click="renderCardProfile" block variant="info" size="sm"><i class="fa fa-search" aria-hidden="true"></i> Search personnel</b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <datalist  id="my-list-id">
                        <option v-for="(item, index) in typeHeadUserSearch" :key="index" >{{ item }}</option>
                    </datalist>
                </b-form-group>
                <!-- pagegination -->
                <div v-if="countObjData">
                    <!-- <h6 class="">Approximately {{ countObjData }} search results</h6> -->
                    <b-pagination
                        id="tutorials-list"
                        class="font-thai"
                        v-model="btnPage"
                        :total-rows="countObjData"
                        :per-page="pageSize"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        @change="handlePageChange"
                    ></b-pagination>
                </div>
                <div v-if="busty">
                    <b-spinner small type="grow"></b-spinner>
                    Loading...
                </div>
                <div v-else>
                    <div class="row mt-4" v-if="dataApiProfileResault.length !== 0">
                        <div 
                            id="tutorials-list"
                            v-for="(item, index) in dataApiProfileResault" :key="index" 
                            class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                        >
                            <b-card class="card-app" no-body>
                                <b-card-text>
                                    <b-media class="mt-3 mb-0 font-thai">
                                        <template v-slot:aside>
                                            <b-img v-if="item.urlPic !== ''" thumbnail class="ml-3 zoom-photo"  style="width:70px;height:70px;" rounded="circle" v-bind:src="`${item.urlPic}`" alt="muicAvtar" ></b-img>
                                            <img v-else src="@/assets/img/avatar.png" style="width:70px;height:70px;" class="rounded-circle img-thumbnail"  alt="avatar.png">
                                        </template>
                                    </b-media>
                                    <b-list-group class="" flush>
                                        <b-list-group-item class="font-thai align-items-center zoom-app">
                                            <h5 class="mt-2 mb-0">
                                                {{ item.fullname_eng }}
                                                <b-link class="text-info" @click="makeToast(item.fullname_eng)"  size="sm" variant="link"><i class="fa fa-files-o align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                            </h5>
                                            <span class="sub-title">
                                                {{ item.fullname_thai }}
                                                <b-link class="text-info" @click="makeToast(item.fullname_thai)"  size="sm" variant="link"><i class="fa fa-files-o align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                            </span>
                                        </b-list-group-item>
                                        <b-list-group-item class="font-thai align-items-center zoom-app">
                                            <mark><i class="fa fa-address-card-o mr-2" aria-hidden="true" />{{ item.staffId }}</mark>
                                            <b-link 
                                                class="text-info"
                                                @click="makeToast(item.staffId)" 
                                                size="sm" variant="link"
                                            ><i class="fa fa-files-o ml-1 align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                        </b-list-group-item>
                                        <b-list-group-item class="font-thai-2 align-items-center zoom-app">
                                            <i class="fa fa fa-envelope ml-1 mr-1" aria-hidden="true"></i>
                                            <a class="h5 font-weight-bold" href="mailto:${item.email}">
                                                <u>{{ item.email }}</u>
                                            </a>
                                            <b-link 
                                                class="text-info"
                                                @click="makeToast(item.email)" 
                                                size="sm" variant="link"
                                            ><i class="fa fa-files-o ml-1 align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                        </b-list-group-item>
                                        <b-list-group-item class="font-thai align-items-center zoom-app">
                                            <mark><i class="fa fa-phone-square mr-2" aria-hidden="true"></i>{{ item.telephone }}</mark>
                                            <b-link 
                                                class="text-info"
                                                @click="makeToast(`${item.telephone}`)" 
                                                size="sm" variant="link"
                                            ><i class="fa fa-files-o ml-1 align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                        </b-list-group-item>
                                        <b-list-group-item class="font-thai align-items-center zoom-app">
                                            <p class="mt-0 mb-0 font-thai text-muted"><i class="fa fa-map-marker mr-2" aria-hidden="true"></i>Position</p>
                                            <p class="font-thai-2 ml-2 mt-2 mb-0">
                                                {{ item.fullposition_eng }}
                                                <b-link
                                                    class="text-info"
                                                    @click="makeToast(item.fullposition_eng)" 
                                                    size="sm" variant="link"
                                                ><i class="fa fa-files-o ml-1 align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                            </p>
                                            <p class="font-thai-2 ml-2 mt-1 mb-0">
                                                {{ item.fullposition_thai }}
                                                <b-link
                                                    class="text-info"
                                                    @click="makeToast(item.fullposition_thai)" 
                                                    size="sm" variant="link"
                                                ><i class="fa fa-files-o ml-1 align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                            </p>
                                        </b-list-group-item>
                                        <b-list-group-item class="font-thai align-items-center zoom-app">
                                            <p class="ml-2 mt-0 mb-0 font-thai text-muted"><i class="fa fa-university mr-2" aria-hidden="true"></i>Department</p>
                                            <p class="font-thai-2 ml-2 mt-2 mb-0">
                                                {{ item.fulldepartment_eng }}
                                                <b-link
                                                    class="text-info"
                                                    @click="makeToast(item.fulldepartment_eng)" 
                                                    size="sm" variant="link"
                                                ><i class="fa fa-files-o ml-1 align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                            </p>
                                            <p class="font-thai-2 ml-2 mt-1 mb-0">
                                                {{ item.fulldepartment_thai }}
                                                <b-link
                                                    class="text-info"
                                                    @click="makeToast(item.fulldepartment_thai)" 
                                                    size="sm" variant="link"
                                                ><i class="fa fa-files-o ml-1 align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                            </p>
                                            <div v-if="item.department_detail_thai !== item.fulldepartment_thai">
                                                <p class="font-thai-2 ml-2 mt-2 mb-0">
                                                    {{ item.department_detail_eng }}
                                                    <b-link
                                                        class="text-info"
                                                        @click="makeToast(item.department_detail_eng)" 
                                                        size="sm" variant="link"
                                                    ><i class="fa fa-files-o ml-1 align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                                </p>
                                                <p class="font-thai-2 ml-2 mt-1 mb-0">
                                                    {{ item.department_detail_thai }}
                                                    <b-link
                                                        class="text-info"
                                                        @click="makeToast(item.department_detail_thai)" 
                                                        size="sm" variant="link"
                                                    ><i class="fa fa-files-o ml-1 align-top L-smallIcon" aria-hidden="true"></i></b-link>
                                                </p>
                                            </div>
                                            <div v-else class="mt-4"></div>
                                        </b-list-group-item>
                                    </b-list-group>
                                </b-card-text>
                                <template v-slot:footer>
                                   <small class="float-right"><em><i class="fa fa-history" aria-hidden="true"></i> {{ moment(item.updated_at).format('LLL') }}</em></small>
                                </template>
                            </b-card>
                        </div>
                    </div>
                    <div v-else><b-alert v-if="HideF" class="mt-2" show variant="warning" dismissible>Not Found</b-alert></div>
                </div>
                <!-- pagegination -->
                <div class="mt-2" v-if="countObjData">
                    <!-- <h6 class="">Approximately {{ countObjData }} search results</h6> -->
                    <b-pagination
                        id="tutorials-list"
                        class="font-thai"
                        v-model="btnPage"
                        :total-rows="countObjData"
                        :per-page="pageSize"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        @change="handlePageChange"
                    ></b-pagination>
                </div>
                <b-alert v-for="msg in errorMsgs" :key="msg.timestamp" class="mt-2" show variant="warning" dismissible>{{ msg.msg }}</b-alert>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-thai{ font-size: 14px; font-family: 'Kanit', sans-serif; font-weight: 500; }
    .font-thai-2{ font-size: 12px; font-family: 'Kanit', sans-serif; font-weight: 500; }
    .font-en{ font-size: 12px; font-family: 'Rubik', sans-serif; }
    .alert-cs {
        background-color: #f3f3f3fa;
        color: #000000;
    }
    .card-app{
        /* Add shadows to create the "card" effect */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
    }
    .L-smallIcon{ font-size: 0.9rem; font-weight: 500; }
</style>

<script>
    // import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
    export default {
        // components: {
        //     VueBootstrapTypeahead
        // },
        data() {
            return {
                HideF:false,
                busty: false,
                errorMsgs:[],
                RegExLanguage : new RegExp(/[ก-ฮ]/),
                query:'',
                typeHeadUserSearch:[],
                dataApiProfileResault:[],
                newQuery:'',
                window: {
                    width: 0,
                    height: 0
                },
                MaxScale:'Monitor',
                // pagegination
                currentIndex: -1,
                btnPage:1,
                offset: 0,
                pageSize: 10,
                countObjData: 0,
                bthNext:null,
                bthPrev:null
            }
        },
        mounted(){},
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            // pagegination
            handlePageChange(value) {
                this.btnPage = value
                this.offset = parseInt(value-1)*parseInt(this.pageSize);
                this.renderCardProfile()
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                if(this.window.width <= 1200){
                    this.MaxScale = 'miniMonitor'
                }else if(this.window.width <= 1366 && this.window.width > 1200){
                    this.MaxScale = 'resMonitor'
                }else{
                    this.MaxScale = 'Monitor'
                }
            },
            makeToast(item_1) {
                let msgCoppy = `${item_1}`
                this.$copyText(msgCoppy).then(function (e) {
                    // console.log(e)
                }, function (e) {
                    // console.log(e)
                })
                const h = this.$createElement
                const vNodesMsg = h( 'p',{ class: ['', 'mb-0'] },
                    [
                        h('p', { class: 'mt-0 mb-0 font-thai' }, item_1),
                    ]
                )
                this.$bvToast.toast([vNodesMsg], 
                    {
                        title: `Copy to clipboard`,
                        autoHideDelay: 5000,
                        variant: 'success',
                        appendToast: true
                    }
                )
            },
            async renderCardProfile(){
                this.HideF = false
                this.busty = true
                this.dataApiProfileResault = []
                if(this.newQuery !== ''){
                    this.errorMsgs = []
                    try {
                        let newText = this.newQuery.replace(/^Assoc.Prof\.|^Asst.Prof\.|^Assoc. Prof. Dr\.|^Asst. Prof. Dr\.|^Asst\.|^Assoc\.|^Mr\.|^Ms\.|^Mrs\.|^Prof\.|^Dr\.|^รศ. พญ\.|^รศ. ดร\.|^ผศ. ดร\.|^ผศ\.|^ดร\.|^พญ\.|^นาย|^รศ\.|^น\.ส\.|^นาง\.*/g,'')
                        // console.log(newText)
                        const res = await this.$http.get(`/directory/?search=${newText}&limit=${this.pageSize}&offset=${this.offset}`)
                        if(res.status === 200){
                            this.dataApiProfileResault =  res.data.results.map(item => {
                                return {
                                    'email': item.email,
                                    'fulldepartment_eng': item.detail_user.fulldepartment_eng,
                                    'fulldepartment_thai': item.detail_user.fulldepartment_thai,
                                    'fullname_eng': item.detail_user.fullname_eng,
                                    'fullname_thai': item.detail_user.fullname_thai,
                                    'fullposition_eng': item.detail_user.fullposition_eng,
                                    'fullposition_thai': item.detail_user.fullposition_thai,
                                    // 
                                    'department_detail_thai': item.department_detail.name_thai,
                                    'department_detail_eng': item.department_detail.name_eng,
                                    // 'urlPic': `https://icapp.muic.mahidol.ac.th/source/pic/${item.id}.jpg`,
                                    'urlPic': item.img,
                                    'telephone': item.telephone,
                                    'updated_at':item.updated_at,
                                    'staffId': item.code,
                                }
                            })
                            this.countObjData = res.data.count
                            this.bthNext = res.data.next
                            this.bthPrev = res.data.previous
                            this.offset = 0
                            this.busty = false
                            this.HideF = true
                        }else{
                            throw { res }
                        }
                    } catch (error) {
                        this.HideF = false
                        this.busty = false
                        this.errorMsgs.push({
                            timestamp: new Date().getTime(),
                            msg: error.res.data
                        });
                        if (this.errorMsgs.length > 1) this.errorMsgs.shift()
                    }
                }else{
                    this.busty = false
                    this.errorMsgs.push({
                        timestamp: new Date().getTime(),
                        msg: 'Specify the information to be searched'
                    });
                    if (this.errorMsgs.length > 1) this.errorMsgs.shift()
                }
            },
            async queryDataTy() {
                try {
                    this.typeHeadUserSearch = []
                    if(this.newQuery !== ''){
                        // thai search
                        if(this.RegExLanguage.test(this.newQuery)){
                            if(this.newQuery.length >= 3){
                                const res = await this.$http.get(`/directory/?search=${this.newQuery}`)
                                if(res.status === 200){
                                    this.typeHeadUserSearch = res.data.map(item => {
                                        const { fullname_thai } = {...item.detail_user};
                                        return `${fullname_thai}`
                                    })
                                }
                            }
                        }
                        // eng search
                        else{
                            if(this.newQuery.length >= 3){
                                const res = await this.$http.get(`/directory/?search=${this.newQuery}`)
                                if(res.status === 200){
                                    this.typeHeadUserSearch = res.data.map(item => {
                                        const { fullname_eng } = {...item.detail_user};
                                        return `${fullname_eng}`
                                    })
                                }
                            }
                        }
                    }
                } catch (error) {}
            }
        },
        watch: {},
    }
</script>